import { LEVEL_WIDTH, TileData, TileType } from "./types";
import { tileKey, type EnemySpawn, type LevelData } from "./level";

// World 1-4: Castle level — underground/brown theme, mostly ground with pits and moving platforms
export function buildLevel4(): LevelData {
  const tiles = new Map<string, TileData>();
  const groundTop = -1;
  const groundDepth = 2;

  const setTile = (x: number, y: number, type: TileType, payload?: TileData["payload"], flower?: boolean): void => {
    tiles.set(tileKey(x, y), { type, payload, broken: false, bump: 0, flower: flower || undefined });
  };

  // castle interior: mostly solid ground with some gaps and pitfalls
  // ground from 0..16
  for (let x = 0; x <= 16; x++) {
    for (let dy = 0; dy < groundDepth; dy++) {
      setTile(x, groundTop - dy, TileType.Ground);
    }
  }

  // pit 1: 17..52
  // gap platforms over pit: x 17..19 (3 tiles), x 22..24 (3), x 27..29 (3), x 32..34 (3), x 37..39 (3), x 42..44 (3), x 47..49 (3), x 52..54 (3)
  for (let x = 17; x <= 52; x += 5) {
    for (let dy = 0; dy < groundDepth; dy++) {
      setTile(x + 2, groundTop - dy, TileType.Ground);
    }
  }

  // ground 53..108
  for (let x = 53; x <= 108; x++) {
    for (let dy = 0; dy < groundDepth; dy++) {
      setTile(x, groundTop - dy, TileType.Ground);
    }
  }

  // pit 2: 109..154 — same pattern
  for (let x = 109; x <= 154; x += 5) {
    for (let dy = 0; dy < groundDepth; dy++) {
      setTile(x + 2, groundTop - dy, TileType.Ground);
    }
  }

  // ground 155..200
  for (let x = 155; x <= 200; x++) {
    for (let dy = 0; dy < groundDepth; dy++) {
      setTile(x, groundTop - dy, TileType.Ground);
    }
  }

  // blocks along the way
  setTile(8, 4, TileType.Question, { kind: "coin" });
  setTile(58, 4, TileType.Brick);
  setTile(59, 4, TileType.Brick);
  setTile(60, 4, TileType.Question, { kind: "coin" });
  setTile(61, 4, TileType.Brick);
  setTile(62, 4, TileType.Brick);

  setTile(70, 4, TileType.Question, { kind: "mushroom" });
  setTile(74, 4, TileType.Brick);
  setTile(75, 4, TileType.Brick);
  setTile(76, 4, TileType.Brick);

  setTile(116, 4, TileType.Question, { kind: "coin" });
  setTile(120, 4, TileType.Brick);
  setTile(121, 4, TileType.Brick);
  setTile(122, 4, TileType.Brick);

  setTile(130, 4, TileType.Question, { kind: "coin" });
  setTile(134, 4, TileType.Brick);
  setTile(135, 4, TileType.Brick);
  setTile(136, 4, TileType.Brick);

  setTile(162, 4, TileType.Question, { kind: "mushroom" });

  // flag at 198, castle at 202
  const flagX = 198;
  for (let y = groundTop + 1; y <= 21; y++) setTile(flagX, y, TileType.Pole);
  setTile(flagX, 22, TileType.Block);

  const castleX = 202;

  const enemies: EnemySpawn[] = [
    { kind: "goomba", x: 23 },
    { kind: "goomba", x: 33 },
    { kind: "goomba", x: 43 },
    { kind: "koopa", x: 58 },
    { kind: "goomba", x: 62 },
    { kind: "goomba", x: 66 },
    { kind: "goomba", x: 72 },
    { kind: "goomba", x: 78 },
    { kind: "koopa", x: 84 },
    { kind: "goomba", x: 90 },
    { kind: "goomba", x: 96 },
    { kind: "goomba", x: 114 },
    { kind: "goomba", x: 124 },
    { kind: "goomba", x: 134 },
    { kind: "koopa", x: 140 },
    { kind: "goomba", x: 146 },
    { kind: "goomba", x: 156 },
    { kind: "goomba", x: 162 },
    { kind: "goomba", x: 170 },
    { kind: "goomba", x: 176 }
  ];

  return { tiles, enemies, enterablePipes: [], flagX, castleX, width: LEVEL_WIDTH, groundY: 0 };
}
